<script>export let id, label = null, error = null, cssClass = '';
</script>

<div class={cssClass}>
    <slot name="label">
        {#if label}
            <label for={id}> {label} </label>
        {/if}
    </slot>
    <slot name="field" />
    <slot name="error">
        {#if error}
            <p class="error">{error}</p>
        {/if}
    </slot>
</div>

<style>
</style>
